import { Directive, ElementRef, Injector, Input, OnInit } from '@angular/core';
@Directive({
  selector: '[farris-label-modification]'
})
export class FarrisLabelModificationDirective implements OnInit {
  @Input() index: number;
  constructor(private injector: Injector, private elementRef: ElementRef) { }
  ngOnInit(): void {
    if (typeof this.index !== 'number' || !this.elementRef) {
      return;
    }
    const nativeElement = this.elementRef.nativeElement;
    if (nativeElement) {
      const labelFor = nativeElement.getAttribute('for');
      if (labelFor) {
        this.elementRef.nativeElement.setAttribute('for', `${labelFor}_${this.index}`);
      }
    }
  }

}
